import React from 'react';
import { Link } from 'react-router-dom';
import { RxCross2 } from 'react-icons/rx';
import { Edit } from 'lucide-react';

const SelectAddressModal: React.FC<any> = ({
  addressDataArr,
  selectedAddress,
  handleSelectAddress,
  setIsOpenSelectAddressModal,
}) => {
  return (
    <>
      <div className='fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50'>
        <div className='bg-white rounded-xl shadow-xl max-w-xs sm:max-w-xs md:max-w-2xl lg:max-w-2xl w-full'>
          <div className=' flex items-center justify-between p-3 border-b  border-gray-200'>
            <h3 className='text-xl font-semibold text-gray-900 dark:text-white'>Billing Address</h3>
            <button
              type='button'
              className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white'
              data-modal-hide='default-modal'
            >
              <RxCross2
                onClick={() => setIsOpenSelectAddressModal(false)}
                className='w-4 h-4 sm:w-4 sm:h-4 md:w-6 md:h-6 lg:w-6 lg:h-6 text-gray-600 hover:text-[#4A2D1A]'
              />
            </button>
          </div>
          <div className='relative bg-white rounded-lg shadow-sm dark:bg-gray-700 p-3'>
            <div className='p-2 mx-auto'>
              {/* Address Cards */}
              <div className='space-y-4  overflow-auto h-[50vh]'>
                {addressDataArr.current.map((address: any, index: any) => {
                  const isSelected = selectedAddress === address.name;

                  return (
                    <div
                      key={index}
                      className={`flex border rounded-md p-4 items-start gap-3 ${isSelected ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-white'}`}
                    >
                      <input
                        type='checkbox'
                        checked={isSelected}
                        // onChange={() => handleSelectAddress(address.name)}
                        onChange={e => {
                          handleSelectAddress(address.name, e.target.checked);
                        }}
                        className='min-h-5 min-w-6 accent-green-700'
                      />
                      <div className='flex-1'>
                        <h4 className='text-sm sm:text-sm md:text-base lg:text-base pb-2 font-poppins'>
                          {address.contacts?.[0]?.name || 'N/A'}
                        </h4>
                        <p className='text-sm text-gray-600 font-poppins pb-2'>
                          {address.address_line1 + ', ' + address.address_line2 + ', ' + address.city + ', '}
                          <br />
                          {address.state + ' - ' + address.pincode + ', ' + address.country}
                        </p>

                        <div className='flex flex-col gap-2 mt-2 text-xs font-poppins pb-2'>
                          <div className='flex flex-col'>
                            <span className='text-xs text-gray-500'>Email</span>
                            <span className='text-sm '> {address.contacts?.[0]?.email_id || '-'}</span>
                          </div>
                          <div className='flex flex-col'>
                            <span className='text-xs  text-gray-500'>Phone</span>
                            <span className='text-sm'>{address.contacts?.[0]?.mobile_no || '-'}</span>
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-between gap-2'>
                        <Link to={`/user/edit-address/${address.name}`}>
                          <Edit className='w-4 h-4 sm:w-4 sm:h-4 md:w-6 md:h-6 lg:w-6 lg:h-6 text-gray-600 hover:text-[#4A2D1A]' />
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectAddressModal;
